/*
 * @Description: 客户退款申请
 */
import { RootObject } from '@/model/rootObject'
import https, { downloadExcel } from '@/utils/https'
import { ContentType, Method } from 'axios-mapper'
import {
  CreateRefundRequestModel, RefundRequestIdListModel,
  RefundRequestListParamModel,
  RefundRequestModel, RefundRequestPageModel, RefundRequestPageParamModel, RefundRequestSetPaymentDateModel,
  RefundSelectedResultModel,
  RefundSetPurposeParamModel,
  UpdateRefundRequestModel

} from '@/model/application-form/paymentRequestRefund'
import networkConfig from '@/config/default/net.config'

const baseUrl = '/base/payment/refund'
export const excelRefundFileUpload = () => {
  return networkConfig.host + baseUrl + '/import/excel'
}
export const createRefundRequest = (params: CreateRefundRequestModel) => {
  return https().request<RootObject<number>>(baseUrl + '/add', Method.POST, params, ContentType.json)
}

export const updateRefundRequest = (params: UpdateRefundRequestModel) => {
  return https().request<RootObject<number>>(baseUrl + '/update', Method.POST, params, ContentType.json)
}

export const getRefundRequestById = (id: number) => {
  return https()
    .request<RootObject<RefundRequestModel>>(baseUrl + '/get/' + id, Method.GET, undefined, ContentType.json)
}

export const getRefundRequestPageList = (params: RefundRequestPageParamModel) => {
  return https().request<RootObject<RefundRequestPageModel>>(baseUrl + '/list', Method.POST, params, ContentType.json)
}

export const getRefundRequestPageListByUser = (params: RefundRequestPageParamModel) => {
  return https()
    .request<RootObject<RefundRequestPageModel>>(baseUrl + '/listByUser', Method.POST, params, ContentType.json)
}

export const getRefundRequestAllList = (params: RefundRequestListParamModel) => {
  return https().request<RootObject<RefundRequestModel[]>>(baseUrl + '/list/all', Method.POST, params, ContentType.json)
}

export const setRefundRequestPaymentDate = (params: RefundRequestSetPaymentDateModel) => {
  return https()
    .request<RootObject<number>>(baseUrl + '/set/paymentDate', Method.POST, params, ContentType.json)
}

export const generateRefundApprovalForms = (params: RefundRequestIdListModel) => {
  return https()
    .request<RootObject<number>>(baseUrl + '/generate/approvalForms', Method.POST, params, ContentType.json)
}

export const getRefundRequestByIds = (params: RefundRequestIdListModel) => {
  return https()
    .request<RootObject<RefundSelectedResultModel[]>>(baseUrl + '/get/selectedApprovalForms', Method.POST, params, ContentType.json)
}
export const cancelRefundApplication = (params: RefundRequestIdListModel) => {
  return https()
    .request<RootObject<number>>(baseUrl + '/cancel/application', Method.POST, params, ContentType.json)
}

export const setRefundSetPurpose = (params: RefundSetPurposeParamModel) => {
  return https()
    .request<RootObject<number>>(baseUrl + '/set/purpose', Method.POST, params, ContentType.json)
}

export const exportRefundTemplate = () => {
  return downloadExcel(baseUrl + '/export/excelTemplate', Method.GET, undefined)
}
